var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cld-image',{attrs:{"public-id":_vm.publicId,"crop":"scale","width":_vm.width,"height":_vm.height,"alt":_vm.publicId}},[_c('cld-transformation',{attrs:{"quality":"auto:low"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }